import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-referaccount',
  templateUrl: './usr-referaccount.component.html',
  styleUrls: ['./usr-referaccount.component.css']
})
export class UsrReferaccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
